export default "__VITE_ASSET__BG9huA9R__"